import { atom } from '@reatom/framework'

import type { DelugeId } from '@root/entities/user-short'
import type { LeaderboardDrawerTab } from '@root/widgets/leaderboard'
import type { RelationsDrawerTab } from '@root/widgets/relations'

export type ProfileTab =
  | 'premium'
  | 'stats'
  | 'positions-active'
  | 'transactions'
  // TODO: check if referral screen is needed
  | 'referral'

export const profileTabAtom = atom<ProfileTab>('stats', 'profileTabAtom')

export const leaderboardTabAtom = atom<LeaderboardDrawerTab | undefined>(
  undefined,
  'leaderboardTabAtom',
)

export const relationTabAtom = atom<RelationsDrawerTab>(
  'followers',
  'relationTabAtom',
)
export const relationDrawerDelugeIdAtom = atom<DelugeId | undefined>(
  undefined,
  'relationDrawerDelugeIdAtom',
)

export const commentsDrawerDelugeIdAtom = atom<DelugeId | undefined>(
  undefined,
  'commentsDrawerDelugeIdAtom',
)

export const inviteDrawerAtom = atom<boolean>(false, 'inviteDrawerAtom')
export const coinsDrawerAtom = atom<boolean>(false, 'coinsDrawerAtom')
export const createCurrencyDrawerAtom = atom<boolean>(
  false,
  'createCurrencyDrawerAtom',
)

export type UserProfileTab = 'stats' | 'coins' | 'transactions'
export const userProfileTabAtom = atom<UserProfileTab>(
  'stats',
  'userProfileTabAtom',
)
